import {
	ReservationMailBulkSendPayload,
	ReservationMailPreviewError,
	ReservationMailPreviewResponse,
} from '@/new-transport/_models/transport-list.model';
import { splitReservationMailPreview } from '@/new-transport/_utils/split-reservation-mail-preview/split-reservation-mail-preview';
import { TransportListApiService } from '@/new-transport/transport-list/_api/transport-list.api.service';
import { Injectable, signal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { MessageGenerateAdapter, MessageTemplate, MessageTemplatePlaceholder } from '../message-generate.model';

@Injectable()
export class ReservationMailGenerateAdapter
	implements
		MessageGenerateAdapter<
			ReservationMailPreviewResponse,
			ReservationMailBulkSendPayload[],
			ReservationMailPreviewError
		>
{
	private readonly previewErrors = signal<ReservationMailPreviewError[]>([]);

	constructor(private readonly api: TransportListApiService) {}

	fetchTemplates(): Observable<MessageTemplate[]> {
		return this.api.getMailTemplateList();
	}

	fetchPlaceholders(templateId: number): Observable<MessageTemplatePlaceholder[]> {
		return this.api.getMailTemplatePlaceholders(templateId);
	}

	createPreview({
		itemsIds,
		message,
		subject,
		template,
	}: {
		itemsIds: number[];
		message: string;
		subject?: string;
		template?: number;
	}): Observable<ReservationMailPreviewResponse[]> {
		return this.api
			.createReservationMailPreview({
				reservations: itemsIds,
				message,
				subject,
				template,
			})
			.pipe(
				map((response) => splitReservationMailPreview(response)),
				tap(({ errors }) => {
					this.previewErrors.set(errors);
				}),
				map(({ previews }) => previews),
			);
	}

	getPreviewErrors(): readonly ReservationMailPreviewError[] {
		return this.previewErrors();
	}

	sendBulk(preview: ReservationMailPreviewResponse[]): Observable<ReservationMailBulkSendPayload[]> {
		const payload = preview.map((item) => ({
			reservation: item.reservationId,
			email: item.email,
			subject: item.subject,
			message: item.message,
		}));
		return this.api.createReservationMailBulkSend(payload);
	}
}
